import { useState } from 'react';
import { AlertTriangle, CreditCard, Loader2 } from 'lucide-react';
import { subscriptionApi } from '@/lib/api';

export default function PastDueBanner() {
  const [loading, setLoading] = useState(false);

  const handleUpdatePayment = async () => {
    setLoading(true);
    try {
      const response = await subscriptionApi.getUpdatePaymentMethodUrl();
      const url = response.data?.url;
      if (url) {
        window.open(url, '_blank');
      }
    } catch {
      window.open('https://polar.sh/purchases/subscriptions', '_blank');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center">
        <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
          <AlertTriangle className="w-8 h-8 text-red-600" />
        </div>

        <h2 className="text-xl font-bold text-slate-900 mb-3">
          Pago pendiente
        </h2>

        <p className="text-slate-600 mb-8">
          No hemos podido procesar tu ultimo pago. Actualiza tu metodo de pago para seguir usando PLEKO sin interrupciones.
        </p>

        <button
          onClick={handleUpdatePayment}
          disabled={loading}
          className="w-full flex items-center justify-center gap-2 px-6 py-3 text-base font-semibold text-white bg-red-600 hover:bg-red-700 rounded-xl transition-colors disabled:opacity-50"
        >
          {loading ? (
            <Loader2 className="w-5 h-5 animate-spin" />
          ) : (
            <CreditCard className="w-5 h-5" />
          )}
          Actualizar metodo de pago
        </button>

        <p className="text-xs text-slate-400 mt-4">
          Si crees que es un error, contacta con soporte en hola@pleko.app
        </p>
      </div>
    </div>
  );
}
